var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "b-card",
                { staticClass: "mb-3" },
                [
                  _c(
                    "b-card-body",
                    [
                      _vm.isAdmin
                        ? _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "12", md: "8", lg: "6" } },
                                [
                                  _c("select-suggestion", {
                                    attrs: {
                                      label: "Filtrar por Pessoa Jurídica",
                                      column: "company_name,trading_name,cnpj",
                                      model: "LegalEntity",
                                      appendClearOption: true,
                                      placeholderText:
                                        "Digite o nome ou cnpj da pessoa jurídica",
                                      itemTextFormat:
                                        _vm.legalEntityItemTextFormat
                                    },
                                    on: {
                                      "selected-model":
                                        _vm.onLegalEntitySelected
                                    },
                                    model: {
                                      value: _vm.selectedLegalEntity,
                                      callback: function($$v) {
                                        _vm.selectedLegalEntity = $$v
                                      },
                                      expression: "selectedLegalEntity"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "b-row",
                        { staticClass: "mt-2" },
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "12", md: "6", lg: "3" } },
                            [
                              _c(
                                "b-form-group",
                                { attrs: { label: "Data Inicial" } },
                                [
                                  _c("b-form-input", {
                                    attrs: { type: "date" },
                                    on: { change: _vm.onPeriodChanged },
                                    model: {
                                      value: _vm.dateStart,
                                      callback: function($$v) {
                                        _vm.dateStart = $$v
                                      },
                                      expression: "dateStart"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { cols: "12", md: "6", lg: "3" } },
                            [
                              _c(
                                "b-form-group",
                                { attrs: { label: "Data Final" } },
                                [
                                  _c("b-form-input", {
                                    attrs: { type: "date" },
                                    on: { change: _vm.onPeriodChanged },
                                    model: {
                                      value: _vm.dateEnd,
                                      callback: function($$v) {
                                        _vm.dateEnd = $$v
                                      },
                                      expression: "dateEnd"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "b-row",
                        { staticClass: "mt-2" },
                        [
                          _c("b-col", { attrs: { cols: "12" } }, [
                            _c(
                              "small",
                              { staticClass: "text-muted d-block mb-2" },
                              [_vm._v("Períodos Rápidos:")]
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "d-flex flex-wrap",
                                staticStyle: { gap: "0.5rem" }
                              },
                              [
                                _c(
                                  "b-button",
                                  {
                                    attrs: {
                                      size: "sm",
                                      variant:
                                        _vm.selectedPeriod === "today"
                                          ? "primary"
                                          : "outline-secondary"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.setPeriod("today")
                                      }
                                    }
                                  },
                                  [_vm._v(" Hoje ")]
                                ),
                                _c(
                                  "b-button",
                                  {
                                    attrs: {
                                      size: "sm",
                                      variant:
                                        _vm.selectedPeriod === "yesterday"
                                          ? "primary"
                                          : "outline-secondary"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.setPeriod("yesterday")
                                      }
                                    }
                                  },
                                  [_vm._v(" Ontem ")]
                                ),
                                _c(
                                  "b-button",
                                  {
                                    attrs: {
                                      size: "sm",
                                      variant:
                                        _vm.selectedPeriod === "7days"
                                          ? "primary"
                                          : "outline-secondary"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.setPeriod("7days")
                                      }
                                    }
                                  },
                                  [_vm._v(" Últimos 7 dias ")]
                                ),
                                _c(
                                  "b-button",
                                  {
                                    attrs: {
                                      size: "sm",
                                      variant:
                                        _vm.selectedPeriod === "15days"
                                          ? "primary"
                                          : "outline-secondary"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.setPeriod("15days")
                                      }
                                    }
                                  },
                                  [_vm._v(" Últimos 15 dias ")]
                                ),
                                _c(
                                  "b-button",
                                  {
                                    attrs: {
                                      size: "sm",
                                      variant:
                                        _vm.selectedPeriod === "30days"
                                          ? "primary"
                                          : "outline-secondary"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.setPeriod("30days")
                                      }
                                    }
                                  },
                                  [_vm._v(" Últimos 30 dias ")]
                                ),
                                _c(
                                  "b-button",
                                  {
                                    attrs: {
                                      size: "sm",
                                      variant:
                                        _vm.selectedPeriod === "thisMonth"
                                          ? "primary"
                                          : "outline-secondary"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.setPeriod("thisMonth")
                                      }
                                    }
                                  },
                                  [_vm._v(" Este mês ")]
                                ),
                                _c(
                                  "b-button",
                                  {
                                    attrs: {
                                      size: "sm",
                                      variant:
                                        _vm.selectedPeriod === "lastMonth"
                                          ? "primary"
                                          : "outline-secondary"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.setPeriod("lastMonth")
                                      }
                                    }
                                  },
                                  [_vm._v(" Mês passado ")]
                                )
                              ],
                              1
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "b-card",
        [
          _c(
            "b-tabs",
            {
              attrs: { "content-class": "mt-3" },
              model: {
                value: _vm.activeTab,
                callback: function($$v) {
                  _vm.activeTab = $$v
                },
                expression: "activeTab"
              }
            },
            [
              _c(
                "b-tab",
                { attrs: { title: "Nível de Criticidade", active: "" } },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "12", lg: "8" } },
                        [
                          _c(
                            "b-card",
                            [
                              _c("b-card-title", [
                                _vm._v("Por Nível de Criticidade")
                              ]),
                              _vm.severityIndicators &&
                              _vm.severityIndicators.length > 0
                                ? _c(
                                    "b-card-body",
                                    [
                                      _c("vue-apex-charts", {
                                        attrs: {
                                          type: "donut",
                                          height: "350",
                                          options: _vm.chartOptions,
                                          series: _vm.chartSeries
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _c(
                                    "b-alert",
                                    {
                                      staticClass: "m-3",
                                      attrs: { show: "", variant: "info" }
                                    },
                                    [_vm._v(" Não há dados para exibir ")]
                                  )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm.totalFormularios > 0
                        ? _c(
                            "b-col",
                            { attrs: { cols: "12", lg: "4" } },
                            [
                              _c(
                                "b-card",
                                [
                                  _c("b-card-body", [
                                    _c(
                                      "div",
                                      { staticClass: "text-center mb-3" },
                                      [
                                        _c("h4", { staticClass: "mb-1" }, [
                                          _vm._v("Total de Formulários")
                                        ]),
                                        _c(
                                          "h2",
                                          { staticClass: "text-primary" },
                                          [_vm._v(_vm._s(_vm.totalFormularios))]
                                        )
                                      ]
                                    ),
                                    _c("hr"),
                                    _vm.severityIndicators &&
                                    _vm.severityIndicators.length > 0
                                      ? _c(
                                          "div",
                                          _vm._l(
                                            _vm.severityIndicators,
                                            function(indicator, index) {
                                              return _c(
                                                "div",
                                                {
                                                  key: index,
                                                  staticClass:
                                                    "d-flex justify-content-between align-items-center mb-3"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "d-flex align-items-center"
                                                    },
                                                    [
                                                      _c("b-badge", {
                                                        staticClass: "mr-2",
                                                        staticStyle: {
                                                          width: "20px",
                                                          height: "20px",
                                                          "border-radius": "4px"
                                                        },
                                                        style: {
                                                          backgroundColor: _vm.getColorForBadge(
                                                            indicator.severity
                                                              .color
                                                          )
                                                        }
                                                      }),
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            indicator.severity
                                                              .label
                                                          )
                                                        )
                                                      ])
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "strong",
                                                    {
                                                      staticClass:
                                                        "text-primary"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(indicator.total)
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            }
                                          ),
                                          0
                                        )
                                      : _vm._e()
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "b-tab",
                { attrs: { title: "Tipo de Relato" } },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "12", lg: "8" } },
                        [
                          _c(
                            "b-card",
                            [
                              _c("b-card-title", [
                                _vm._v("Por Tipo de Relato")
                              ]),
                              _vm.typeReportingIndicators &&
                              _vm.typeReportingIndicators.length > 0
                                ? _c(
                                    "b-card-body",
                                    [
                                      _c("vue-apex-charts", {
                                        attrs: {
                                          type: "donut",
                                          height: "350",
                                          options:
                                            _vm.typeReportingChartOptions,
                                          series: _vm.typeReportingChartSeries
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _c(
                                    "b-alert",
                                    {
                                      staticClass: "m-3",
                                      attrs: { show: "", variant: "info" }
                                    },
                                    [_vm._v(" Não há dados para exibir ")]
                                  )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm.totalTypeReporting > 0
                        ? _c(
                            "b-col",
                            { attrs: { cols: "12", lg: "4" } },
                            [
                              _c(
                                "b-card",
                                [
                                  _c("b-card-body", [
                                    _c(
                                      "div",
                                      { staticClass: "text-center mb-3" },
                                      [
                                        _c("h4", { staticClass: "mb-1" }, [
                                          _vm._v("Total por Tipo")
                                        ]),
                                        _c(
                                          "h2",
                                          { staticClass: "text-primary" },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.totalTypeReporting)
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _c("hr"),
                                    _vm.typeReportingIndicators &&
                                    _vm.typeReportingIndicators.length > 0
                                      ? _c(
                                          "div",
                                          _vm._l(
                                            _vm.typeReportingIndicators,
                                            function(indicator, index) {
                                              return _c(
                                                "div",
                                                {
                                                  key: index,
                                                  staticClass:
                                                    "d-flex justify-content-between align-items-start mb-3"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "d-flex align-items-start flex-grow-1",
                                                      staticStyle: {
                                                        "min-width": "0"
                                                      }
                                                    },
                                                    [
                                                      _c("b-badge", {
                                                        staticClass:
                                                          "mr-2 flex-shrink-0",
                                                        staticStyle: {
                                                          width: "20px",
                                                          height: "20px",
                                                          "border-radius":
                                                            "4px",
                                                          "margin-top": "2px"
                                                        },
                                                        style: {
                                                          backgroundColor: _vm.getColorForTypeReporting(
                                                            indicator
                                                              .type_reporting.id
                                                          )
                                                        }
                                                      }),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "text-break",
                                                          staticStyle: {
                                                            "word-wrap":
                                                              "break-word",
                                                            "overflow-wrap":
                                                              "break-word"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              indicator
                                                                .type_reporting
                                                                .name
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "strong",
                                                    {
                                                      staticClass:
                                                        "text-primary flex-shrink-0 ml-2"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(indicator.total)
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            }
                                          ),
                                          0
                                        )
                                      : _vm._e()
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "b-tab",
                { attrs: { title: "Situação do Tratamento" } },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "12", lg: "8" } },
                        [
                          _c(
                            "b-card",
                            [
                              _c("b-card-title", [
                                _vm._v("Por Situação do Tratamento")
                              ]),
                              _vm.statusIndicators &&
                              _vm.statusIndicators.length > 0
                                ? _c(
                                    "b-card-body",
                                    [
                                      _c("vue-apex-charts", {
                                        attrs: {
                                          type: "donut",
                                          height: "350",
                                          options: _vm.statusChartOptions,
                                          series: _vm.statusChartSeries
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _c(
                                    "b-alert",
                                    {
                                      staticClass: "m-3",
                                      attrs: { show: "", variant: "info" }
                                    },
                                    [_vm._v(" Não há dados para exibir ")]
                                  )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm.totalStatus > 0
                        ? _c(
                            "b-col",
                            { attrs: { cols: "12", lg: "4" } },
                            [
                              _c(
                                "b-card",
                                [
                                  _c("b-card-body", [
                                    _c(
                                      "div",
                                      { staticClass: "text-center mb-3" },
                                      [
                                        _c("h4", { staticClass: "mb-1" }, [
                                          _vm._v("Total por Situação")
                                        ]),
                                        _c(
                                          "h2",
                                          { staticClass: "text-primary" },
                                          [_vm._v(_vm._s(_vm.totalStatus))]
                                        )
                                      ]
                                    ),
                                    _c("hr"),
                                    _vm.statusIndicators &&
                                    _vm.statusIndicators.length > 0
                                      ? _c(
                                          "div",
                                          _vm._l(_vm.statusIndicators, function(
                                            indicator,
                                            index
                                          ) {
                                            return _c(
                                              "div",
                                              {
                                                key: index,
                                                staticClass:
                                                  "d-flex justify-content-between align-items-center mb-3"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "d-flex align-items-center"
                                                  },
                                                  [
                                                    _c("HandlingStatusBadge", {
                                                      staticClass: "mr-2",
                                                      attrs: {
                                                        color:
                                                          indicator.status
                                                            .color,
                                                        label:
                                                          indicator.status.label
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "strong",
                                                  {
                                                    staticClass: "text-primary"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(indicator.total)
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          }),
                                          0
                                        )
                                      : _vm._e()
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "b-tab",
                { attrs: { title: "Identificação" } },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "12", lg: "8" } },
                        [
                          _c(
                            "b-card",
                            [
                              _c("b-card-title", [_vm._v("Por Identificação")]),
                              _vm.identificationIndicators &&
                              _vm.identificationIndicators.length > 0
                                ? _c(
                                    "b-card-body",
                                    [
                                      _c("vue-apex-charts", {
                                        attrs: {
                                          type: "donut",
                                          height: "350",
                                          options:
                                            _vm.identificationChartOptions,
                                          series: _vm.identificationChartSeries
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _c(
                                    "b-alert",
                                    {
                                      staticClass: "m-3",
                                      attrs: { show: "", variant: "info" }
                                    },
                                    [_vm._v(" Não há dados para exibir ")]
                                  )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm.totalIdentification > 0
                        ? _c(
                            "b-col",
                            { attrs: { cols: "12", lg: "4" } },
                            [
                              _c(
                                "b-card",
                                [
                                  _c("b-card-body", [
                                    _c(
                                      "div",
                                      { staticClass: "text-center mb-3" },
                                      [
                                        _c("h4", { staticClass: "mb-1" }, [
                                          _vm._v("Total por Identificação")
                                        ]),
                                        _c(
                                          "h2",
                                          { staticClass: "text-primary" },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.totalIdentification)
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _c("hr"),
                                    _vm.identificationIndicators &&
                                    _vm.identificationIndicators.length > 0
                                      ? _c(
                                          "div",
                                          _vm._l(
                                            _vm.identificationIndicators,
                                            function(indicator, index) {
                                              return _c(
                                                "div",
                                                {
                                                  key: index,
                                                  staticClass:
                                                    "d-flex justify-content-between align-items-center mb-3"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "d-flex align-items-center"
                                                    },
                                                    [
                                                      _c("b-badge", {
                                                        staticClass: "mr-2",
                                                        staticStyle: {
                                                          width: "20px",
                                                          height: "20px",
                                                          "border-radius": "4px"
                                                        },
                                                        style: {
                                                          backgroundColor: indicator.is_identify
                                                            ? "#28C76F"
                                                            : "#82868B"
                                                        }
                                                      }),
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            indicator.identification_status
                                                          )
                                                        )
                                                      ])
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "strong",
                                                    {
                                                      staticClass:
                                                        "text-primary"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(indicator.total)
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            }
                                          ),
                                          0
                                        )
                                      : _vm._e()
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }